// Mock data for the Group Change sub-resource picker (Slack channels).
//
// IMPORTANT: the backend endpoints these simulate do NOT exist yet in
// core-entity (there is no `/group-change/.../sub-resources` route and no
// sub-resource concept on the backend). This mock exists purely so the picker
// UI can be exercised under `npm run dev:mock`. Remove/replace once the real
// backend contract lands.

export const SLACK_SUB_RESOURCE_APP_ID = '5acc0000-054f-11ee-be56-0242ac120099';

// Shapes mirror the core-entity response (snake_case); the api slice's
// transformResponse camelizes them, so the mock must match the real wire format.
export type MockSubResource = {
  id: string;
  name: string;
  member_count: number;
  // For the removed context, `already_member: true` means the channel is shared
  // with a group the employee is staying in -> rendered read-only ("No action
  // needed"). For the added context it means already-assigned via another group.
  already_member: boolean;
};

export const slackChannelsRemoved: MockSubResource[] = [
  {
    id: 'ch-eng-general',
    name: '#engineering-general',
    member_count: 124,
    already_member: false,
  },
  {
    id: 'ch-incident-response',
    name: '#incident-response',
    member_count: 42,
    already_member: false,
  },
  {
    id: 'ch-eng-leads',
    name: '#eng-leads',
    member_count: 9,
    already_member: false,
  },
  {
    id: 'ch-company-announcements',
    name: '#company-announcements',
    member_count: 350,
    already_member: true,
  },
  { id: 'ch-random', name: '#random', member_count: 210, already_member: true },
];

export const slackChannelsAdded: MockSubResource[] = [
  {
    id: 'ch-design-team',
    name: '#design-team',
    member_count: 18,
    already_member: false,
  },
  {
    id: 'ch-figma-updates',
    name: '#figma-updates',
    member_count: 33,
    already_member: false,
  },
  {
    id: 'ch-design-critique',
    name: '#design-critique',
    member_count: 12,
    already_member: false,
  },
  {
    id: 'ch-company-announcements',
    name: '#company-announcements',
    member_count: 350,
    already_member: true,
  },
];
